export const ADMIN_MODE_STORAGE_KEY = 'ek:admin-mode'

export const getLocalStorage = (): Storage | null => {
	try {
		return typeof globalThis.localStorage === 'undefined' ? null : globalThis.localStorage
	} catch {
		return null
	}
}
